(() => {
  const safeDestination = (value) => {
    if (!value) return '';
    try {
      const url = new URL(value, window.location.origin);
      return url.origin === window.location.origin ? url.pathname : url.hostname;
    } catch {
      return '';
    }
  };

  let isPublishing = false;

  const publish = (eventName, details = {}) => {
    if (!eventName || isPublishing) return;
    isPublishing = true;

    try {
      const payload = {
        event_name: eventName,
        template: document.body?.dataset.hsTemplate || '',
        market: document.body?.dataset.hsMarket || 'PK',
        ...details,
      };

      const publishResult = window.Shopify?.analytics?.publish?.(`hs_apparel:${eventName}`, payload);
      publishResult?.catch?.(() => {});

      document.dispatchEvent(new CustomEvent('hs:analytics-published', { detail: payload }));
    } finally {
      isPublishing = false;
    }
  };

  document.addEventListener('click', (event) => {
    const target = event.target.closest('[data-hs-event]');
    if (target && target.dataset.hsEvent !== 'wishlist_toggle') {
      publish(target.dataset.hsEvent, { destination: safeDestination(target.getAttribute('href')) });
    }

    const link = event.target.closest('a');
    if (link?.matches('a[href*="/products/"]') && document.body.dataset.hsTemplate === 'search') {
      publish('search_result_click', { destination: safeDestination(link.href) });
    }
    if (link?.matches('a[href*="condition-guide"]')) publish('condition_guide_open');
    if (link?.matches('a[href*="size-guide"], a[href*="how-we-measure"]')) publish('size_guide_open');
    if (event.target.closest('.product__media, .product-media-container')) publish('product_image_interaction');
  });

  document.addEventListener('submit', (event) => {
    if (
      event.target.matches('.newsletter-form, form[action*="/contact"]') &&
      event.target.querySelector('input[name="contact[tags]"][value="newsletter"]')
    ) {
      publish('newsletter_signup');
    }
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('#SortBy, select[name="sort_by"]')) publish('sort_use', { value: event.target.value });
    if (event.target.closest('facet-filters-form, .facets-container')) {
      publish('filter_use', { control: event.target.name || event.target.id || '' });
    }
  });

  document.addEventListener('hs:commerce', (event) => {
    if (!event.detail?.hs_event_name) return;
    const { hs_event_name: eventName, ...details } = event.detail;
    publish(eventName, details);
  });

  const searchState = document.querySelector('[data-hs-search-state]');
  if (searchState?.dataset.performed === 'true' && Number(searchState.dataset.results) === 0) {
    publish('zero_result_search');
  }
})();

